<template>
  <div :class="['tprs', className]">
    <span class="tprs__label">To Pass requires</span>
    <div class="tprs__track" role="group" aria-label="To Pass requirement">
      <button
        v-for="option in TO_PASS_OPTIONS"
        :key="option"
        type="button"
        class="tprs__tab"
        :class="{
          'tprs__tab--active': toPass === option,
          'tprs__tab--active-default': toPass === option && option === 'Quiz and Inspection',
        }"
        :aria-pressed="String(toPass === option)"
        :aria-label="option"
        @click="select(option)"
      >
        {{ option }}
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  toPass: {
    type: String,
    default: "Quiz and Inspection",
    validator: (value) => ["Quiz and Inspection", "Quiz Only", "Inspection Only"].includes(value),
  },
  className: {
    type: String,
    default: "",
  },
});

const TO_PASS_OPTIONS = ["Quiz and Inspection", "Quiz Only", "Inspection Only"];

const emit = defineEmits(["update:toPass"]);

function select(option) {
  if (props.toPass === option) return;
  emit("update:toPass", option);
}
</script>

<style scoped>
.tprs {
  display: flex;
  align-items: center;
  gap: 20px;
  font-family: Inter, sans-serif;
}

.tprs__label {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  color: #101828;
  white-space: nowrap;
}

.tprs__track {
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border-radius: 8px;
  background: #f2f4f7;
}

.tprs__tab {
  margin: 0;
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  background: transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: #475467;
  white-space: nowrap;
  cursor: pointer;
}

.tprs__tab:focus-visible {
  outline: 2px solid #7f56d9;
  outline-offset: 2px;
}

.tprs__tab--active {
  background: #ffffff;
  color: #101828;
  font-weight: 700;
  box-shadow: 0 1px 1px rgba(16, 24, 40, 0.05);
}

.tprs__tab--active-default {
  font-weight: 600;
}
</style>
